import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-circles-animation',
    imports: [],
    templateUrl: './circles-animation.html',
    styleUrl: './circles-animation.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CirclesAnimation {}
